<template>
　<div v-if="show" class="cx_mfa">

        <!-- SMS認証初期化-->                
        <b-modal v-model="m_initialize" @ok="onInitialize" @cancel="logout" title="SMS認証設定" ok-title="設定する" cancel-title="ログイン画面に戻る" hide-header-close>
            <div class="description">
                <span>携帯電話によるSMS認証を有効化するとセキュリティが向上します。複数端末でのご利用時は有効化してください。</span>
                <b-form-checkbox v-model="useSMS">SMS認証を有効化する</b-form-checkbox>
            </div>
        </b-modal>
        <!-- SMS認証実施-->    
        <b-modal v-model="m_send_sms" @ok="onSendSMS" @cancel="logout" title="認証コードの送信" ok-title="認証コードを送信する" cancel-title="ログイン画面に戻る" hide-header-close>
            <div class="description">
                <span>登録された携帯電話番号にSMSを送信します。</span>
                <TextBox title="携帯電話番号" :value.sync="telNo" :enabled="false"/>    
                <div class="reset"><span class="cx_link_item" @click="onSendSMSReset">SMS認証の解除</span> </div> 
            </div>
        </b-modal>              
        <!-- 重複セッションエラー-->                   
        <b-modal v-model="m_duplicate_session" @ok="onDuplicateSession" @cancel="logout" title="認証エラー" ok-title="SMS認証を設定する" cancel-title="ログイン画面に戻る" hide-header-close>
            <div class="description">
                <!-- <span>他の端末で利用中のため、ご利用いただけません。複数端末でのご利用時はSMS認証を設定してください。</span>    -->
                <span>他の端末でログイン中のため、ご利用いただけません。複数端末でご利用される場合はSMS認証を設定してください。<br>※SMS認証は不定期で発生します。</span>                   
            </div>
        </b-modal>          
        <!-- SMS認証設定(session)-->        
        <b-modal v-model="m_update_session" @ok="m_initialize_sms = true" @cancel="close(false)" title="SMS認証設定" ok-title="SMS認証を有効化する" cancel-title="閉じる" hide-header-close>
            <div class="description">
                <!-- <span>携帯電話によるSMS認証を有効化するとセキュリティが向上し、複数端末でご利用いただけるようになります。</span>    -->
                <span>SMS認証を有効化すると複数端末でご利用いただけます。<br>※SMS認証は不定期で発生します。</span>                   
            </div>
        </b-modal>           
        <!-- SMS認証設定(sms)-->                  
        <b-modal v-model="m_update_sms" @ok="onUpdateSMS"  @cancel="close(false)"  title="SMS認証設定" ok-title="設定する" cancel-title="閉じる" hide-header-close>
            <div class="description">
                <span>SMS認証の解除もしくは携帯電話番号を変更します。</span>   
                <b-form-radio-group v-model="updateTelNo" >
                    <b-form-radio  :value="false">SMS認証を解除する</b-form-radio>
                    <b-form-radio  :value="true">携帯電話番号を変更する</b-form-radio>
                </b-form-radio-group>                
            </div>
        </b-modal>        
        <!-- SMS認証解除 -->             
        <b-modal v-model="m_reset_confirm" @ok="onResetConfirm" @cancel="logout" title="SMS認証解除" ok-title="SMS認証を解除する" cancel-title="ログイン画面に戻る" hide-header-close>
            <div class="description">
                <!-- <span>SMS認証を解除すると複数端末で利用いただけなくなります。よろしいですか？</span> -->
                <span>SMS認証を解除してよろしいですか？</span>                      
            </div>
        </b-modal>           
        <!-- SMS認証解除無効 -->                         
        <b-modal v-model="m_reset_invalid" @ok="onResetInvalid" ok-only title="SMS認証解除" ok-title="SMS認証画面に戻る" hide-header-close>
            <div class="description">
                <span>SMS認証の解除コードが無効です。</span>        
            </div>
        </b-modal>                       


        <!-- 後続ダイアログ -->
        <b-modal v-model="m_initialize_sms" @ok="onInitializeSMS" @cancel="onInitializeSMSCancel" title="携帯電話番号の指定" ok-title="認証コードを送信する" cancel-title="戻る" hide-header-close>
            <div class="description">
                <span>SMSメッセージを受信できる日本国内の携帯電話番号を指定してください。※ハイフン(-)は入力不要です。</span>
                <TextBox title="携帯電話番号" :value.sync="telNo" :required="true" :isEdit="true" regex="^[0-9]{11}$" regexMessage="11桁の数字を指定してください。" ref="telNo"/>      
            </div>
        </b-modal>            
        <b-modal v-model="m_validate_code" @ok="onValidateCode" @cancel="onValidateCodeCancel" title="認証コードの確認" ok-title="認証する" cancel-title="戻る" hide-header-close>
            <div class="description">
                <span>送付されたSMSメッセージに記載された4桁の認証コードを入力してください。</span>
                <TextBox title="認証コード" :value.sync="authenticationCode" :required="true" :isEdit="true" regex="^[0-9]{4}$" regexMessage="4桁の数字を指定してください。" ref="authenticationCode"/>      
            </div>
        </b-modal>                
        <b-modal v-model="m_reset_sms" @ok="onResetSMS" @cancel="onResetSMSCancel" title="SMS認証解除" ok-title="解除リンクを送信する" cancel-title="戻る" hide-header-close>
            <div class="description">
                <span>SMS認証の解除リンクをメールアドレスに送信します。よろしいですか？</span>   
            </div>
        </b-modal>                            
        <b-modal v-model="m_reset_sms_wait" title="SMS認証解除" hideFooter  hide-header-close>
            <div class="description">
                <span>SMS認証の解除リンクを送付しました。メールを確認してください。</span>   
                <span>メールアドレス : {{$api.auth.userId}}</span>                   
            </div>
        </b-modal>    
        <b-modal v-model="m_result" @ok="close(reload)" title="SMS認証設定" ok-only ok-title="閉じる" hide-header-close>
            <div class="description">
                <span>{{message}}</span>                 
            </div>
        </b-modal>    
        <b-modal v-model="m_invalid_code" @ok="onInvalidCode" title="SMS認証失敗" ok-only ok-title="戻る" hide-header-close>
            <div class="description">
                <span>認証コードが一致しませんでした。再度、認証コードを送信してください。</span>                 
            </div>
        </b-modal>            
    </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';



@Component
export default class MultiFactorAuthentication extends Vue {
  @Prop({default:null}) public mode : Common.mfaFlags;
  show :boolean = true;

  //エントリダイアログ
  m_initialize = false;
  m_send_sms = false;  
  m_duplicate_session = false;
  m_update_session = false;
  m_update_sms = false;  
  m_reset_confirm = false;
  m_reset_invalid = false;

  //後続ダイアログ
  m_initialize_sms = false;
  m_validate_code = false;  
  m_reset_sms = false;  
  m_reset_sms_wait = false;  
  m_result = false;
  m_invalid_code = false;
  //プロパティ
  useSMS:boolean = false;
  updateTelNo = false;
  

  public telNo : string = '';
  public authenticationCode :string = '';
  public authenticationHash : string = '';

  public message = '';
  public reload = false;

  public created(){
    if (this.mode == Common.mfaFlags.initialize) this.m_initialize = true;
    else if (this.mode == Common.mfaFlags.duplicate_session) this.m_duplicate_session = true;
    else if (this.mode == Common.mfaFlags.send_sms) this.$api.multiFactorAuthenticate(new Common.MFASettingQuery()).then(result => {this.telNo = (result as Common.MFASetting).smsTelNo; this.m_send_sms = true;});
    else if (this.mode == Common.mfaFlags.update_session) this.m_update_session = true;
    else if (this.mode == Common.mfaFlags.update_sms) this.m_update_sms = true;
    else if (this.mode == Common.mfaFlags.reset_sms) this.m_reset_sms = true;        
    else if (this.mode == Common.mfaFlags.reset_confirm) this.m_reset_confirm = true;            
    else if (this.mode == Common.mfaFlags.reset_invalid) this.m_reset_invalid = true;              
  }

  public logout(){
      //ログアウト
      this.show = false;      
      this.$api.auth.logout();
  }

  public showResult(enabled:boolean, reload : boolean){

      this.message = enabled ? 'SMS認証を有効化しました。':'SMS認証を無効化しました。';
      this.reload = reload;
      this.m_result = true;
  }

  public close(reload:boolean){
      this.show = false;
      if (reload) {
          if (location.href.indexOf('?') > -1) location.href = location.href.substring(0,location.href.indexOf('?') -1);          
          else location.reload();
      }
  }

　//***初期化画面***
  public onInitialize(){
      if (this.useSMS) this.m_initialize_sms = true;
      else {
          //セッション認証を初期化する
        this.$api.multiFactorAuthenticate(new Common.MFAInvalidateQuery()).then(result =>{
            this.showResult(false, true);
        });               
      }
  }

　//***SMS初期化***
　public onInitializeSMS(event:any){
     const textBox = (this.$refs.telNo as any) as Components.IControl;
     if (textBox.validator.validate() == false) {
         event.preventDefault();
         return;
     }
     //認証コードをSMSに送信
     this.$api.multiFactorAuthenticate(new Common.SMSSendCodeQuery(this.telNo)).then(hash =>{
        this.authenticationHash = hash;
        this.m_validate_code = true;
     });     
　}
   public onInitializeSMSCancel(){
       //初期化・再設定の開始画面に戻る
       if (this.mode == Common.mfaFlags.initialize) this.m_initialize = true;
       else if (this.mode == Common.mfaFlags.duplicate_session) this.m_duplicate_session = true;
       else if (this.mode == Common.mfaFlags.update_session) this.m_update_session = true;
       else if (this.mode == Common.mfaFlags.update_sms) this.m_update_sms = true;       
   }

　//***認証実施***
   public onValidateCode(event : any){
     const textBox = (this.$refs.authenticationCode as any) as Components.IControl;
     if (textBox.validator.validate() == false) {
         event.preventDefault();
         return;
     }
     var initialize = this.mode == Common.mfaFlags.send_sms ? false : true; //認証以外は初期化・リセット系
     this.$api.multiFactorAuthenticate(new Common.SMSValidateCodeQuery(this.telNo,this.authenticationCode,this.authenticationHash, initialize)).then(result =>{        
        if (result) { 
            if (initialize) this.showResult(true, true);
            else this.close(true);
        }
        else this.m_invalid_code = true; //結果表示後、再度、認証コード送信画面に遷移。
     });          
   }

   public onValidateCodeCancel(){
       //「認証コードの送信」もしくは「携帯電話番号の指定」に戻る
      if (this.mode ==  Common.mfaFlags.send_sms) this.m_send_sms = true;
      else this.m_initialize_sms = true;
   }

　//***セッション重複エラー***
　public onDuplicateSession(){
     this.m_initialize_sms = true;
   }

　//***認証コード送信***
   public onSendSMS(){
     //認証コードをSMSに送信～telNoはマスクされているので送らない
     this.$api.multiFactorAuthenticate(new Common.SMSSendCodeQuery(null)).then(hash =>{
        this.authenticationHash = hash;
        this.m_validate_code = true;
     });            
   }
   public onSendSMSReset(){
       this.m_send_sms = false;
       this.m_reset_sms = true;       
   }
   public onUpdateSMS() {
       if (this.updateTelNo) this.m_initialize_sms = true;
       else {
        //SMS認証解除
        this.$api.multiFactorAuthenticate(new Common.MFAInvalidateQuery()).then(result =>{
            this.showResult(false, false); //リロード不要
        });                     
       }
   }

   public onResetSMS() {
       //SMS認証解除メールを送信する
        //SMS認証解除
        this.$api.multiFactorAuthenticate(new Common.MFAResetMailQuery()).then(result =>{
            this.m_reset_sms_wait = true;
        });    
   }

   public onResetSMSCancel(){
       this.m_send_sms = true;
   }

   public onResetConfirm() {
        this.$api.multiFactorAuthenticate(new Common.MFAInvalidateQuery()).then(result =>{
            this.showResult(false, true); //リロード必要  
        });             
   }

   public onResetInvalid(){
        this.close(true); //リロード必要             
   }

   public onInvalidCode(){
       if (this.mode == Common.mfaFlags.send_sms) this.m_send_sms = true;
       else this.m_initialize_sms = true;
   }
}
</script>
<style lang="scss">
.cx_mfa{
    .description {
        font-size: 15px;
        margin : 10px 20px;
        display: flex;
        flex-direction: column;
        align-items:center;

        span{
            margin-bottom: 20px;
        }
        .cx_control {
            font-size :15px;
        }
        .form-control-sm{
            font-size: 18px;
            height: 25px;
        }

        .reset {
            margin-top:20px;
            width:400px;
            text-align: right;
            font-size:13px;
        }
    }
}
</style>